const model = { t: 'Model', name: 'model', hint: { url: '/model/truck', deps: ['marka'], cache: 'truck-model', exact: true }}
export default model